import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const Banner = styled.div`
    position: relative;
    width: 100%;
    margin: 0;
    background: radial-gradient(ellipse at center, #0f0f1b 0%, #000000 100%);
    color: white;
    height: 100vh;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    .__color_background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.2;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .earth-glow {
        position: absolute;
        bottom: 140px;
        left: 50%;
        transform: translateX(-50%) rotate(180deg);
        width: 1549px;
        height: 1461px;
        z-index: 1;
        border-radius: 50%;
        opacity: 0.4;
        pointer-events: none;
        background: radial-gradient(
            60.42% 60.42% at 50.02% 60.42%,
            rgba(255, 255, 255, 0.00) 0%,
            rgba(255, 255, 255, 0.00) 69.42%,
            rgba(255, 255, 255, 0.08) 75.33%,
            rgba(255, 255, 255, 0.13) 80.42%,
            rgba(255, 255, 255, 0.31) 86.39%,
            rgba(255, 255, 255, 0.57) 92.19%,
            #ffffff 100%
        );
        box-shadow: 0px -20px 40px 0px rgba(255, 255, 255, 0.60);
        border: 1px solid #FFF;
        mix-blend-mode: luminosity;
    }

    .cta-container {
        text-align: center;
        padding: 3rem;
        position: relative;
        margin-bottom: 6%;
        z-index: 11;
        
@keyframes scroll {
    0% {
        transform: translateX(0)
    }

    to {
        transform: translateX(-100%)
    }
}

@keyframes scroll {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

.text-scoll {
    display: flex;
    animation: scroll 60s linear infinite;
    white-space: nowrap;
}

.scroll-container {
    display: flex;
}

.scroll-content {
    display: flex;
    gap: 50px;
    div{
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 1.3rem;
    color: #fff;
    }
}

        h1 {
            font-size: 5rem;
            font-weight: 700;
            line-height: 1.1;
            margin-bottom: 1rem;
            margin: 0 auto;

            @media (max-width: 768px) {
                font-size: 2.4rem;
                max-width: 640px;

            }

            @media (max-width: 480px) {
                font-size: 2rem;
                max-width: 340px;
                margin: 0 auto;
            }

            span{
            font-size: 6rem;
            @media (max-width: 768px) {
                font-size: 3rem;
            }

            @media (max-width: 480px) {
                font-size: 2.5rem;
            }

            }
        }

        .cta-subtext {
            color: rgba(255, 255, 255, 0.5);
            font-size: 1.2rem;
            display: flex;
            justify-content: center;
            gap: 2rem;
            flex-wrap: wrap;
            max-width: 70%;
            margin: 0 auto;
            margin-bottom: 2.5rem;

            @media (max-width: 768px) {
               font-size: 1rem;
            }

        }
    }
`;